import { isSuccess } from '@/context/services/type';
import { useBulkDestroyInvoiceReports } from 'ap-openapi';
import { useCallback } from 'react';

export const useBulkDeleteInvoiceReportService = () => {
  const { mutateAsync: _mutateAsync } = useBulkDestroyInvoiceReports();
  const mutateAsync = useCallback(
    async (ids: string[]): Promise<boolean> => {
      const resp = await _mutateAsync({ data: { report_ids: ids } });
      if (isSuccess(resp.status)) return true;
      throw resp.data;
    },
    [_mutateAsync]
  );
  return { mutateAsync };
};
